// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2AbvT","label":"Radio_label__2rRrh","checkMark":"Radio_checkMark__2UcHh","disabled":"Radio_disabled__3U6mC"};